import React from "react";
import styled from "styled-components";
import { ArrowDown, ArrowUp } from "lucide-react";
import { WeekReport } from "src/database/models/GoalSummary";
import { getRatio, getPercentage } from "./utils";

interface Props {
  summary: WeekReport;
  weekSummaries: WeekReport[];
  /** Narrower bar and text for inline goal row layout. */
  compact?: boolean;
}

export function GoalSummary({ summary, weekSummaries, compact }: Props) {
  const ratio = getRatio(summary);
  const lastWeek =
    weekSummaries.length > 0 ? weekSummaries[weekSummaries.length - 1] : { completed: 0, total: 0 };
  const lastWeekRatio = lastWeek.total === 0 ? 1 : lastWeek.completed / lastWeek.total;
  const improvement = (ratio - lastWeekRatio) * 100;
  return (
    <Summary>
      <ProgressBar $compact={compact}>
        <Progress $size={ratio} />
        <ProgressText>
          <ProgressPercentage>{getPercentage(summary)}%</ProgressPercentage>
          <ProgressRatio>
            ({summary.completed}/{summary.total})
          </ProgressRatio>
        </ProgressText>
      </ProgressBar>
      <Improvement>
        {improvement >= 0 ? (
          <ArrowUp size={12} color="#4caf50" />
        ) : (
          <ArrowDown size={12} color="#f44336" />
        )}
        <span>{Math.abs(Math.floor(improvement))}%</span>
      </Improvement>
    </Summary>
  );
}

const Summary = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const ProgressBar = styled.div<{ $compact?: boolean }>`
  width: ${({ $compact }) => ($compact ? 100 : 150)}px;
  flex-shrink: 0;
  height: 24px;
  background-color: var(--box-color-contrast);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
`;

const Progress = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size * 100}%;
  height: 100%;
  background-color: var(--theme-color-primary);
`;

const ProgressText = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 3px 6px;
  font-size: 12px;
  letter-spacing: 0.01em;
  mix-blend-mode: difference;
  color: #fff;
`;

const ProgressPercentage = styled.span``;

const ProgressRatio = styled.span`
  color: #ddd;
`;

const Improvement = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
`;
